export default "__VITE_ASSET___QNh036G__"